import { AvvirEvent } from "type_aliases";

export type SetProjectImportingEvent = AvvirEvent<typeof SET_PROJECT_IMPORTING, { projectId: string, importing: boolean }>

// Marks (or unmarks) a project as having a data import in progress that *this* client initiated.
// The project reducer records this in a dedicated `importingByFirebaseId` map (not the project's own
// `isLocked`), so a project refetch mid-import can't clobber it. getProjectIsLocked ORs this optimistic
// flag together with the server-side `isLocked`, which is only re-fetched when the import finishes or the
// page reloads.
const setProjectImporting = (projectId: string, importing: boolean): SetProjectImportingEvent => ({
  type: SET_PROJECT_IMPORTING,
  payload: {
    projectId,
    importing
  }
});

export const SET_PROJECT_IMPORTING = "set_project_importing";

export default setProjectImporting;
